/*
 * File: App.tsx
 * Project: Mdsi-Template-App
 * -----
 * Last Modified: 02 Dec 2020 5:55:21 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

// import { useDispatch, useSelector } from 'react-redux';

import { Layout, Row } from 'antd';
import { Loader } from 'components/atoms/Loader';
import { PageHeader } from 'components/organisms/PageHeader';
import { PageSubHeader } from 'components/organisms/PageSubHeader';
import { About } from 'features/about/About';
import { EditProfilePage } from 'features/editProfile/EditProfile';
import { Home } from 'features/home/Home';
import { POReceipt } from 'features/poReceipt/POReceipt';
import { useAuthentication } from 'hooks/useAuthentication';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Route, Switch } from 'react-router-dom';
import { InlineStylesModel } from '../models/InlineStylesModel';

const { Header, Content } = Layout;

const customLayout: React.CSSProperties = {
  width: '100vw',
  height: '100vh'
};

const customMainRow: React.CSSProperties = {
  height: '100vh'
};

const styles: InlineStylesModel = {
  layoutDesktop: {
    minHeight: '100vh',
    minWidth: '635px'
  },
  layoutMobile: {
    minHeight: '100vh'
  },
  header: {},
  content: {
    padding: '10px 50px',
    maxWidth: 1920
  },
  somethingWrong: {
    textAlign: 'center',
    height: '100vh'
  }
};

function App(): JSX.Element {
  const { accessToken, isLoading } = useAuthentication();

  if (isLoading || accessToken === null) {
    return (
      <Row justify="center" align="middle" style={{ height: '100vh' }}>
        <Loader />
      </Row>
    );
  }

  return (
    <Layout style={isMobileOnly ? styles.layoutMobile : styles.layoutDesktop}>
      <Header style={{ padding: 0 }}>
        <PageHeader />
      </Header>
      <PageSubHeader />
      <Row justify="center">
        <Content style={styles.content}>
          <Switch>
            <Route path="/profile/" component={EditProfilePage} />
            <Route path="/about" component={About} />
            <Route path="/" exact component={Home} />
            <Route path="/:PoReceiptId" exact component={POReceipt} />
          </Switch>
        </Content>
      </Row>
    </Layout>
  );
}

export default App;
